import { useRecordContext, useTranslate } from 'react-admin';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';
import type { Contact } from '../../../types/chat.types';
import { useDateFormat } from '../../../utils/dateFormat';

export const ContactDetails = () => {
  const record = useRecordContext<Contact>();
  const { formatDateTime } = useDateFormat();
  const translate = useTranslate();
  if (!record) return null;

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {translate('resources.contact.details')}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.contact.fields.uuid')}
            </Typography>
            <Typography variant="body2">{record.uuid}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.contact.fields.email')}
            </Typography>
            <Typography variant="body2">{record.email || '-'}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.contact.fields.phoneNumber')}
            </Typography>
            <Typography variant="body2">{record.phoneNumber || '-'}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.contact.fields.createdAt')}
            </Typography>
            <Typography variant="body2">
              {formatDateTime(record.createdAt)}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.contact.lastActivity')}
            </Typography>
            <Typography variant="body2">
              {record.lastActivityAt
                ? formatDateTime(record.lastActivityAt)
                : '-'}
            </Typography>
          </Box>

        </Box>

        {record.customFields && Object.keys(record.customFields).length > 0 && (
          <Box mt={2}>
            <Typography variant="caption" color="textSecondary">
              {translate('resources.contact.customFields')}
            </Typography>
            <Box
              component="pre"
              sx={{
                bgcolor: 'action.hover',
                p: 1,
                borderRadius: 1,
                fontSize: 12,
                overflow: 'auto',
              }}
            >
              {JSON.stringify(record.customFields, null, 2)}
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
